export default {
  "icon": "_icon_1ju4e7",
  "header": "_header_1ju4e7",
  "title": "_title_1ju4e7",
  "subtitle": "_subtitle_1ju4e7"
};